import { motion } from "framer-motion";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Faq() {
  return (
    <div className="min-h-screen" data-testid="faq-page">
      <Nav />

      <main className="max-w-[1100px] mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-24 min-h-[60vh]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="overline mb-6" data-testid="faq-overline">FAQ</div>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] text-white-fade mb-8" data-testid="faq-heading">
            Questions, <span className="italic text-cosmic">answered.</span>
          </h1>
          <p className="max-w-2xl text-ink-dim text-base md:text-lg leading-relaxed" data-testid="faq-placeholder">
            This page is reserved for frequently asked questions. Content coming soon.
          </p>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
